




































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwTextarea from "@/encoding/components/buildingBlocks/Textarea.vue";

export default Vue.extend({
    components: {
        iwAccordion: iwAccordion,
        iwTextarea: iwTextarea,
    },

    props: {
        selected: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: function() {
        return {
            specificId: uuidv4() as string,
            info: "",
        };
    },

    methods: {
        emitUpdate: function() {
            this.$emit("update", {
                type: "OTHER",
                info: this.info,
            });
        },

        updateInfo: function(info: string) {
            this.info = info;
            this.emitUpdate();
        },
    },
});
